import {Injectable} from '@angular/core';
import {IVMessageBoxConfiguration} from "@apps/vhq/src/app/common/interfaces/message-box/IVMessageBoxConfiguration";
import {messageBoxType} from "@apps/vhq/src/app/common/enums/messagebox.enum";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class VhqMessageBoxService {
  messageBoxConfig$: Subject<IVMessageBoxConfiguration> = new Subject<IVMessageBoxConfiguration>();

  showMessageBox(config: IVMessageBoxConfiguration): void {
    this.messageBoxConfig$.next(config);
  }
}
